// One Word Art style tile for the picker. Renders the customer's typed word
// in the preset's look (a mini SVG via WordArtText) with a fidelity note.
// Falls back to a short placeholder before the customer types. Mirrors
// FontTile's shape so it slots into the same picker grid.

import type { WordArtPreset } from "../wordart/presets";
import { WordArtText } from "./WordArtText";

const FIDELITY_LABEL: Record<WordArtPreset["fidelity"], string> = {
  faithful: "Stitches true to preview",
  "thread-approximated": "Thread-colour version when stitched",
  "needs-review": "On-screen preview, stitch to be confirmed",
};

export function WordArtStyleTile({
  preset,
  text,
  selected,
  onClick,
}: {
  preset: WordArtPreset;
  text: string;
  selected: boolean;
  onClick: () => void;
}) {
  const raw = text.trim() ? text : "DAD";
  return (
    <button
      type="button"
      className={`rk-pc-wa-tile${selected ? " is-selected" : ""}`}
      onClick={onClick}
    >
      <span className="rk-pc-wa-tile__preview">
        <svg
          viewBox="0 0 200 84"
          width="100%"
          role="img"
          aria-label={preset.name}
        >
          <WordArtText
            box={{ cx: 100, cy: 46, w: 176, fontMm: 34 }}
            text={raw}
            preset={preset}
            colour={preset.sampleHex}
            filterId={null}
          />
        </svg>
      </span>
      <span className="rk-pc-wa-tile__name">{preset.name}</span>
      <span className="rk-pc-wa-tile__fidelity">
        {FIDELITY_LABEL[preset.fidelity]}
      </span>
    </button>
  );
}
